// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginFooter_container__2tV_P","legals":"LoginFooter_legals__3t0IO"};